import { render, staticRenderFns } from "./HotelWrap.vue?vue&type=template&id=6748aa98"
import script from "./HotelWrap.vue?vue&type=script&lang=js"
export * from "./HotelWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports